<template>
  <v-container fluid>
    <patient-header />
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>QR-коды для авторизации</v-card-title>
          <v-card-text>
            <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
            <v-row v-if="!loading && qrCodes.length > 0" justify="center">
              <v-col v-for="item in qrCodes" :key="item.id" cols="12" sm="6" md="4" lg="3">
                <v-card outlined>
                  <v-card-text class="text-center">
                    <h3 class="mb-3">{{ item.name }}</h3>
                    <canvas :ref="`qr-${item.id}`" class="qr-canvas"></canvas>
                    <p class="mt-2 text--secondary">{{ item.description }}</p>
                  </v-card-text>
                  <v-card-actions v-if="item.link" class="justify-center">
                    <v-btn :href="item.link" target="_blank" text color="primary">Перейти</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import QRCode from "qrcode";
import PatientHeader from "@/components/PatientHeader.vue";
import { getQrCodes } from "./qr-codes.services.js";

export default Vue.extend({
  components: { PatientHeader },
  data() {
    return {
      qrCodes: [],
      loading: true,
    };
  },
  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },
  async created() {
    await this.loadQrCodes();
  },
  updated() {
    this.renderQrCodes();
  },
  methods: {
    getDefaultQrCodes() {
      return [
        {
          id: "default-1",
          name: "Сервис авторизации",
          description: "QR-код для авторизации в стороннем сервисе",
          data: "https://example.com/auth?token=DEFAULT_QR_DATA",
        },
      ];
    },
    async loadQrCodes() {
      try {
        this.loading = true;
        const codes = await getQrCodes(this.customerId);
        this.qrCodes = codes.length > 0 ? codes : this.getDefaultQrCodes();
      } catch (error) {
        console.error("Ошибка загрузки QR-кодов =>", error);
        this.qrCodes = this.getDefaultQrCodes();
      } finally {
        this.loading = false;
      }
    },
    renderQrCodes() {
      this.qrCodes.forEach(item => {
        const canvasRef = this.$refs[`qr-${item.id}`];
        if (canvasRef && canvasRef[0] && item.data) {
          QRCode.toCanvas(canvasRef[0], item.data, { width: 200, margin: 2 }, error => {
            if (error) console.error("Ошибка генерации QR-кода =>", error);
          });
        }
      });
    },
  },
});
</script>

<style scoped>
.qr-canvas {
  margin: 0 auto;
  display: block;
}
</style>
